import { render, staticRenderFns } from "./UpdateContainerForm.vue?vue&type=template&id=71f3b86e&scoped=true&"
import script from "./UpdateContainerForm.vue?vue&type=script&lang=ts&"
export * from "./UpdateContainerForm.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateContainerForm.vue?vue&type=style&index=0&id=71f3b86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f3b86e",
  null
  
)

export default component.exports